package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class ExpenseEntryQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    item_id: String,
    label: String,
    amount: Long,
    date: String?,
    note: String?,
    tx_id: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(1_379_208_241, arrayOf("expense_entry"), driver, "ExpenseEntry.sq",
      "selectAll",
      "SELECT expense_entry.id, expense_entry.item_id, expense_entry.label, expense_entry.amount, expense_entry.date, expense_entry.note, expense_entry.tx_id, expense_entry.order_index, expense_entry.created_at, expense_entry.updated_at, expense_entry.is_deleted, expense_entry.deleted_at, expense_entry.synced_at FROM expense_entry WHERE is_deleted = 0 ORDER BY item_id, date, created_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getLong(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11),
      cursor.getLong(12)
    )
  }

  public fun selectAll(): Query<Expense_entry> = selectAll { id, item_id, label, amount, date, note,
      tx_id, order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Expense_entry(
      id,
      item_id,
      label,
      amount,
      date,
      note,
      tx_id,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByItem(item_id: String, mapper: (
    id: String,
    item_id: String,
    label: String,
    amount: Long,
    date: String?,
    note: String?,
    tx_id: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByItemQuery(item_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getLong(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11),
      cursor.getLong(12)
    )
  }

  public fun selectByItem(item_id: String): Query<Expense_entry> = selectByItem(item_id) { id,
      item_id_, label, amount, date, note, tx_id, order_index, created_at, updated_at, is_deleted,
      deleted_at, synced_at ->
    Expense_entry(
      id,
      item_id_,
      label,
      amount,
      date,
      note,
      tx_id,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> totalForItem(item_id: String, mapper: (n: Long, total: Long) -> T): Query<T>
      = TotalForItemQuery(item_id) { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getLong(1)!!
    )
  }

  public fun totalForItem(item_id: String): Query<TotalForItem> = totalForItem(item_id) { n,
      total ->
    TotalForItem(
      n,
      total
    )
  }

  public fun paidForItem(item_id: String): Query<Long> = PaidForItemQuery(item_id) { cursor ->
    cursor.getLong(0)!!
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    item_id: String,
    label: String,
    amount: Long,
    date: String?,
    note: String?,
    tx_id: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-1_723_084_190, arrayOf("expense_entry"), driver, "ExpenseEntry.sq",
      "selectDirty",
      "SELECT expense_entry.id, expense_entry.item_id, expense_entry.label, expense_entry.amount, expense_entry.date, expense_entry.note, expense_entry.tx_id, expense_entry.order_index, expense_entry.created_at, expense_entry.updated_at, expense_entry.is_deleted, expense_entry.deleted_at, expense_entry.synced_at FROM expense_entry WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getLong(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11),
      cursor.getLong(12)
    )
  }

  public fun selectDirty(): Query<Expense_entry> = selectDirty { id, item_id, label, amount, date,
      note, tx_id, order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Expense_entry(
      id,
      item_id,
      label,
      amount,
      date,
      note,
      tx_id,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    item_id: String,
    label: String,
    amount: Long,
    date: String?,
    note: String?,
    tx_id: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getLong(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11),
      cursor.getLong(12)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Expense_entry> = selectByIdAnyState(id) { id_,
      item_id, label, amount, date, note, tx_id, order_index, created_at, updated_at, is_deleted,
      deleted_at, synced_at ->
    Expense_entry(
      id_,
      item_id,
      label,
      amount,
      date,
      note,
      tx_id,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    item_id: String,
    label: String,
    amount: Long,
    date: String?,
    note: String?,
    tx_id: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(-834_076_403, """
        |INSERT INTO expense_entry(id, item_id, label, amount, date, note, tx_id, order_index, created_at, updated_at)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 10) {
          bindString(0, id)
          bindString(1, item_id)
          bindString(2, label)
          bindLong(3, amount)
          bindString(4, date)
          bindString(5, note)
          bindString(6, tx_id)
          bindLong(7, order_index)
          bindLong(8, created_at)
          bindLong(9, updated_at)
        }
    notifyQueries(-834_076_403) { emit ->
      emit("expense_entry")
    }
  }

  public fun update(
    label: String,
    amount: Long,
    date: String?,
    note: String?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-489_130_211,
        """UPDATE expense_entry SET label = ?, amount = ?, date = ?, note = ?, updated_at = ? WHERE id = ?""",
        6) {
          bindString(0, label)
          bindLong(1, amount)
          bindString(2, date)
          bindString(3, note)
          bindLong(4, updated_at)
          bindString(5, id)
        }
    notifyQueries(-489_130_211) { emit ->
      emit("expense_entry")
    }
  }

  public fun setTx(
    tx_id: String?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_228_987_826,
        """UPDATE expense_entry SET tx_id = ?, updated_at = ? WHERE id = ?""", 3) {
          bindString(0, tx_id)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(1_228_987_826) { emit ->
      emit("expense_entry")
    }
  }

  public fun updateFromRemote(
    item_id: String,
    label: String,
    amount: Long,
    date: String?,
    note: String?,
    tx_id: String?,
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_455_417_229,
        """UPDATE expense_entry SET item_id = ?, label = ?, amount = ?, date = ?, note = ?, tx_id = ?, order_index = ?, updated_at = ? WHERE id = ?""",
        9) {
          bindString(0, item_id)
          bindString(1, label)
          bindLong(2, amount)
          bindString(3, date)
          bindString(4, note)
          bindString(5, tx_id)
          bindLong(6, order_index)
          bindLong(7, updated_at)
          bindString(8, id)
        }
    notifyQueries(1_455_417_229) { emit ->
      emit("expense_entry")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(866_718_409,
        """UPDATE expense_entry SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""",
        3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(866_718_409) { emit ->
      emit("expense_entry")
    }
  }

  public fun softDeleteForList(
    deleted_at: Long?,
    updated_at: Long,
    list_id: String,
  ) {
    driver.execute(-1_410_095_618, """
        |UPDATE expense_entry SET is_deleted = 1, deleted_at = ?, updated_at = ?
        |WHERE is_deleted = 0 AND item_id IN (SELECT id FROM expense_list_item WHERE list_id = ?)
        """.trimMargin(), 3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, list_id)
        }
    notifyQueries(-1_410_095_618) { emit ->
      emit("expense_entry")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(-946_184_518,
        """UPDATE expense_entry SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(-946_184_518) { emit ->
      emit("expense_entry")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(2_069_612_027,
        """UPDATE expense_entry SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(2_069_612_027) { emit ->
      emit("expense_entry")
    }
  }

  private inner class SelectByItemQuery<out T : Any>(
    public val item_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("expense_entry", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("expense_entry", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_919_706_246,
        """SELECT expense_entry.id, expense_entry.item_id, expense_entry.label, expense_entry.amount, expense_entry.date, expense_entry.note, expense_entry.tx_id, expense_entry.order_index, expense_entry.created_at, expense_entry.updated_at, expense_entry.is_deleted, expense_entry.deleted_at, expense_entry.synced_at FROM expense_entry WHERE item_id = ? AND is_deleted = 0 ORDER BY date, created_at""",
        mapper, 1) {
      bindString(0, item_id)
    }

    override fun toString(): String = "ExpenseEntry.sq:selectByItem"
  }

  private inner class TotalForItemQuery<out T : Any>(
    public val item_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("expense_entry", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("expense_entry", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(694_249_196,
        """SELECT count(*) AS n, coalesce(sum(amount), 0) AS total FROM expense_entry WHERE item_id = ? AND is_deleted = 0""",
        mapper, 1) {
      bindString(0, item_id)
    }

    override fun toString(): String = "ExpenseEntry.sq:totalForItem"
  }

  private inner class PaidForItemQuery<out T : Any>(
    public val item_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("expense_entry", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("expense_entry", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-525_976_260,
        """SELECT coalesce(sum(amount), 0) AS paid FROM expense_entry WHERE item_id = ? AND is_deleted = 0 AND tx_id IS NOT NULL""",
        mapper, 1) {
      bindString(0, item_id)
    }

    override fun toString(): String = "ExpenseEntry.sq:paidForItem"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("expense_entry", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("expense_entry", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_759_327_385,
        """SELECT expense_entry.id, expense_entry.item_id, expense_entry.label, expense_entry.amount, expense_entry.date, expense_entry.note, expense_entry.tx_id, expense_entry.order_index, expense_entry.created_at, expense_entry.updated_at, expense_entry.is_deleted, expense_entry.deleted_at, expense_entry.synced_at FROM expense_entry WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "ExpenseEntry.sq:selectByIdAnyState"
  }
}
